import { useInfiniteQuery } from "@tanstack/react-query"
import { websiteProductService } from "@/api/websiteProductService"

type ProductFilters = {
  tag_id?: number
  category_id?: number[]
  search?: string
  per_page?: number
  page?: number
  size_id?: number[]
  color_id?: number[]
}

export const useWebsiteProducts = (filters: ProductFilters = {}) => {
  return useInfiniteQuery({
    queryKey: ["website-products", filters],
    queryFn: ({ pageParam = 1, signal }) =>
      // websiteProductService.getProducts({ ...filters, page: pageParam as number }, signal),
      websiteProductService.getProductGroups(
        { ...filters, page: pageParam as number },
        signal
      ),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      // Assuming generic API response structure with meta or links
      // You might need to adjust this based on your actual API response
      // typically: lastPage.meta.current_page < lastPage.meta.last_page ? lastPage.meta.current_page + 1 : undefined
      const meta = (lastPage as any)?.data?.meta
      if (meta && meta.current_page < meta.last_page) {
        return meta.current_page + 1
      }
      return undefined
    },
  })
}
